module.exports = __webpack_public_path__ + "static/media/inbound-carousel-1.0b838e24.png";